<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.welding.title')" header-tag="h3" class="bg-default-card">
                    <data-table-collapse
                        v-if="tableLoaded"
                        :exportable="false"
                        :importable="false"
                        title=""
                        :rows="getData.rowData"
                        :columns="columnData"
                        :perPage="perPage"
                        :rowsCount="rowsCount"
                        :currentPage="currentPage"
                        :pageCount="pageCount"
                        :rowChangeSelectOptions="rowChangeSelectOptions"
                        
                        @rowClickParts="onParts"
                        @rowClickEdit="onEditRow"
                        @rowClickCheck="onClickCheckSpool"
                        @rowChangeUpdate="onClickChangeUpdate"
                        @rowClickPDF="onPDF('table', ...arguments)"
                        @changePage="changePage"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                        >
                    </data-table-collapse>

                    <span v-if="this.$store.getters.hasPermission(['project_isometric'], ['read']) && getData.rowData.length > 0" @click="onPDF('button', ...arguments)">
                        <label v-if="!this.$store.state.ajax_in_progress" class="btn btn-dark mt-3 text-white">
                            <span><i class="fa fa-file-pdf-o mr-1"></i> {{ $t('general.buttons.pdf_button') + this.currentPage }}</span>
                        </label>
                        <label v-else class="btn btn-dark mt-3 text-white disabled">
                            <span><i class="fa fa-file-pdf-o mr-1"></i> {{ $t('general.ajax_in_progress_please_wait') }}</span>
                        </label>
                    </span>
                </b-card>

                <div class="row" v-if="this.$store.getters.hasPermission(['project_isometric'], ['read']) && this.$store.getters.hasPermission(['project_weld'], ['read']) && getData.rowData.length > 0">
                    <div class="col-sm-12">
                        <i class="fa fa-2x fa-link"></i> - {{$t('general.welding.title2')}}
                    </div>
                </div>
            </div>
        </div>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="saveModal" id="saveModal" :title="actionTitle" size="lg" @ok="saveAction" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_line'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('general.welding.weld.stats_table.rt_bw_erection') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.rt_bw_erection" name="rt_bw_erection">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('general.welding.weld.stats_table.vt') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.visual_test" name="visual_test">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('general.welding.weld.stats_table.pmi') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.pmi" name="pmi">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('general.welding.weld.stats_table.mt') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.nde_extent_mt" name="nde_extent_mt">
                        </div>
                    </div>
					<div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('general.welding.weld.stats_table.rt_bw_prefab') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.rt_bw_prefab" name="rt_bw_prefab">
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('general.welding.weld.stats_table.rt') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.nde_extent_rt" name="nde_extent_rt">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('general.welding.weld.stats_table.pt') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.nde_extent_pt" name="nde_extent_pt">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('general.welding.weld.stats_table.others') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.nde_extent_others" name="nde_extent_others">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('general.welding.weld.stats_table.ut') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.nde_extent_ut" name="nde_extent_ut">
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <confirm-dialog ref="pdfModal" :title="actionTitlePdf" @buttonClick="onDownloadPDF">
            <p class="m-0">{{ download_pdf_message }}</p>
        </confirm-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
import http from '@/libs/http';
import DataTableCollapse from '@/components/global/tables/datatables/DataTableCollapse.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import miniToastr from 'mini-toastr';
import Multiselect from 'vue-multiselect';

export default {
    name: 'weld_iso',
    components: {
        DataTableCollapse,
        ConfirmDialog,
        Multiselect,
    },
    data() {
        return {
            rowChangeSelectOptions: {},
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/'
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.welding.title'),
                    active: true
                }
            ],
            tableName: 'drawing',
            tableNameTranslated: Vue.i18n.translate('general.welding.weld.title_modal'),
            row: null,
            rowHistory: null,
            rowSpool: null,
            tableLoaded: false,
            actionTitlePdf: '',
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            actionTitle: '',
            download_pdf_message: '',
            pdfType: null,

            isDisciplineLoading: false,
            currentDiscipline: [],
            selectedDiscipline: {},

            isTeamLoading: false,
            currentTeam: [],
            selectedTeam: {},

            isLineLoading: false,
            currentLine: [],
            selectedLine: {},

            isWorkTypeLoading: false,
            selectedWorkType: {},
            currentWorkType: [],
            getData: {
                rowData: [],
                getTeams: [],
                getFiles: [],
                workHistoryData: [],
                spoolData: []
            },
            model: {
                rt_bw_erection: null,
                rt_bw_prefab: null,
                pmi: null,
                nde_extent_rt: null,
                nde_extent_ut: null,
                nde_extent_mt: null,
                nde_extent_pt: null,
                nde_extent_others: null,
                visual_test: null
            },

            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '130px',
                    field: '',
                    showEditButton: true,
                    showPartsButton: false,
                    showPDF: false,
                },
                {
                    label: Vue.i18n.translate('table.area'),
                    field: 'line.area',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.serial_no'),
                    field: 'line.serial_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.line_no'),
                    field: 'line.line_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.iso_no'),
                    field: 'iso_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.page_no'),
                    field: 'page',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.field_area'),
                    field: 'field_area',
                    numeric: false,
                    html: false,
                }
            ]
        }
    },
    mounted() {
        this.onLoadTable();
    },
    computed: {
        drawing_priority: {
            get () {
                let drawing_priority = this.$store.getters.getDrawingPriority;
                return drawing_priority;
            }
        }
    },
    watch: {
        drawing_priority: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        model: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
                this.model.delayed = Boolean(newVal.delayed);
            }
        }
    },
    methods: {
        onPDF (type, row) {
            this.pdfType = type;
            switch(this.pdfType) {
                case 'table':   
                    this.actionTitlePdf = Vue.i18n.translate('modal.general.download_pdf');
                    this.download_pdf_message = Vue.i18n.translate('messages.download_pdf');
                    break;
                case 'button':
                    this.actionTitlePdf = Vue.i18n.translate('modal.general.download_pdfs');
                    this.download_pdf_message = Vue.i18n.translate('messages.download_pdfs');
                    break;
            }
            this.row = row;
            this.$refs.pdfModal.show();
        },
        onDownloadPDF (button) {
            if(button == 1) {
                switch(this.pdfType) {
                    case 'table':
                        let data = http.route('drawing/' + this.row.id).get(
                        {
                            export_weld_pdf: 1,
                        }, true);
                        data.then(response => {
                            if (!response.isError) {
                                miniToastr.success(Vue.i18n.translate('messages.pdf_generated'), Vue.i18n.translate('messages.success'));
                                let data = http.route('get_content/drawing_weld/'+response.data.id+'/'+response.data.name).downloadPdf({}, response.data.name).then(res => {});
                            } else {
                                miniToastr.error(Vue.i18n.translate('errors.error_generating_pdf'), Vue.i18n.translate('messages.error'));
                            }
                        });
                        break;
                    case 'button':
                        this.getData.rowData.forEach(row => {
                            let data = http.route('drawing/' + row.id).get(
                            {
                                export_weld_pdf: 1,
                            }, true);
                            data.then(response => {
                                if (!response.isError) {
                                    miniToastr.success(Vue.i18n.translate('messages.pdf_generated'), Vue.i18n.translate('messages.success'));
                                    let data = http.route('get_content/drawing_weld/'+response.data.id+'/'+response.data.name).downloadPdf({}, response.data.name).then(res => {});
                                } else {
                                    miniToastr.error(Vue.i18n.translate('errors.error_generating_pdf'), Vue.i18n.translate('messages.error'));
                                }
                            });
                        })
                        break;
                }
            }
            this.$refs.pdfModal.hide();
        },
        done(type) {
            this.onLoadTable();
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.$refs.weldModal.clear();
            this.$refs.weldModal.show();
        },
        clearSearches () {
            this.currentDiscipline = [];
            this.currentTeam = [];
            this.currentLine = [];
            this.currentWorkType = [];
            this.selectedTeam = {};
            this.selectedLine = {};
            this.selectedWorkType = {};
            this.selectedDiscipline = {};
        },
        onParts (row) {
            this.$router.push({name: 'weld', params: {id:this.$route.params.id, id2: row.id}});
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            if (this.$store.getters.hasPermission(['project_isometric'], ['read'])) {
                let data = http.route(this.tableName + '?filters[parent_drawing_id]=null&filters[welding_documentation]=1&project_id='+this.$route.params.id+'&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType + '&filters[discipline_id]=1').get();
                data.then(response => {
                    if (!response.isError) {
                        this.perPage = response.pagination.limit;
                        this.rowsCount = response.pagination.totalEntries;
                        this.currentPage = response.pagination.currentPage;
                        this.pageCount = response.pagination.totalPages;
                        var data = response.data;
                        data.forEach(field => {
                            if (typeof response.other != 'undefined') {
                                if (typeof response.other.collapsible_headers != 'undefined') {
                                    field.collapsible_headers = response.other.collapsible_headers;
                                }
                                if (typeof response.other.collapsible_headers2 != 'undefined') {
                                    field.collapsible_headers2 = response.other.collapsible_headers2;
                                }
                                if (typeof response.other.collapsible_headers3 != 'undefined') {
                                    field.collapsible_headers3 = response.other.collapsible_headers3;
                                }
                                if (typeof response.other.collapsible_title != 'undefined') {
                                    field.collapsible_title = response.other.collapsible_title;
                                }
                                if (typeof response.other.collapsible_title2 != 'undefined') {
                                    field.collapsible_title2 = response.other.collapsible_title2;
                                }
                                if (typeof response.other.collapsible_title3 != 'undefined') {
                                    field.collapsible_title3 = response.other.collapsible_title3;
                                }
                            }

                            if((field.work_type_id == null || field.work_type_id == '')) {
                                field.work_type = { 'key': '' };
                            }

                            if((field.line_id == null || field.line_id == '')) {
                                field.line = {
                                    'line_number': '',
                                    'insulation_or_tracing_type': '',
                                    'painting_code': '',
                                    'test_circuit_no': '',
                                    'tie_in_no': ''
                                };
                            }

                            field.show_parts_button = this.$store.getters.hasPermission(['project_weld'], ['read']);
                            field.show_pdf = this.$store.getters.hasPermission(['project_isometric'], ['read']);
                        });
                        this.getData.rowData = data;
                        this.tableLoaded = true;
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            } else {
                this.errorMsg(Vue.i18n.translate('errors.permission.read'));
            }
        },
        onClickCheckSpool(row, column, value) {
            if (row) {
                var clone = Object.assign({}, row);
                clone[column.toString()] = (value == null || value == 0) ? 1 : 0;
                // console.log(clone[column.toString()]);
                for (var key in clone) {
                    if (typeof clone[key] == 'object' && clone[key] != null) {
                        // console.log(clone[key]);
                        clone[key] = clone[key]['value'];
                    }
                }

                let data = http.route('spool/' + row.id).patch(clone, true);
                data.then(response => {
                    if(response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                    }
                });
            }
        },
        onClickChangeUpdate(row, column, value) {
            if (row) {
                let to_put = {
                    id: row.id,
                    line_id: row.line_id,
                    drawing_id: row.drawing_id,

                    remark1: row.remark_1.value,
                    remark2: row.remark_2.value,
                }
                http.route('spool/' + row.id).patch(to_put, true).then(response => {
                    if (response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                    }
                });
            }
        },

        onEditRow (row, index) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
            this.row = row;

            this.model.rt_bw_erection = this.row.rt_bw_erection;
            this.model.rt_bw_prefab   = this.row.rt_bw_prefab;
            this.model.vt             = this.row.vt;
            this.model.pmi            = this.row.pmi;
            //this.model.bht            = this.row.bht;
            this.model.nde_extent_rt  = this.row.nde_extent_rt;
            this.model.nde_extent_pt  = this.row.nde_extent_pt;
            this.model.nde_extent_mt  = this.row.nde_extent_mt;
            this.model.nde_extent_ut  = this.row.nde_extent_ut;
            this.model.nde_extent_others  = this.row.nde_extent_others;
            this.model.visual_test    = this.row.visual_test;
            this.model.at             = this.row.at;
            this.model.fn             = this.row.fn;
            this.model.others         = this.row.others;

            this.$refs.saveModal.show();
        },
        saveAction (e) {
            e.preventDefault();

            let put_data = {
                rt_bw_erection: this.model.rt_bw_erection,
                rt_bw_prefab:   this.model.rt_bw_prefab,
                vt:             this.model.vt,
                pmi:            this.model.pmi,
                at:             this.model.at,
                fn:             this.model.fn,
                others:         this.model.others,

                line_id:        this.row.line_id,
                page:           this.row.page,
                iso_no:         this.row.iso_no,
            }

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            if (this.row) {
                var row = this.row;
                var vm = this;
                    
                http.route('drawing/' + this.row.id).patch(put_data, true).then(response => {
                    if(response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        let put_data2 = {
                                        project_id:     vm.$route.params.id,
                                        line_number:    row.line_number,

                                        nde_extent_others:  vm.model.nde_extent_others,
                                        nde_extent_rt:  vm.model.nde_extent_rt,
                                        nde_extent_pt:  vm.model.nde_extent_pt,
                                        nde_extent_mt:  vm.model.nde_extent_mt,
                                        nde_extent_ut:  vm.model.nde_extent_ut,
                                        visual_test:  vm.model.visual_test,
                                        }

                        http.route('line/' + put_data.line_id).patch(put_data2, true).then(response => {
                            if(response.data == false) {
                                Object.keys(response.errorMessage).forEach(key => {
                                    this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                                });
                            } else {
                                this.$refs.saveModal.hide();
                                this.onLoadTable();
                                this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                            }
                        });
                    }
                });
            } else {
                this.errorMsg(Vue.i18n.translate('messages.not_found'));
            }
        }
    }
}
</script>

<style scoped>
    select {
        -webkit-appearance:menulist-button;
        -moz-appearance:menulist-button;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/project/welding/welds/weld_iso.vue